function hashCode(s) {
	// TO IMPLEMENT - HEBREW CHARS AS IDs CAUSING ERROR IN CONSOLE AFTER CLICK
	return s;
}

function makeIds () {
	let content = document.querySelector('.main-content')
	if (!content) {
		return
	}
	let headings = content.querySelectorAll('h2')
	let headingMap = {}
	Array.prototype.forEach.call(headings, function (heading) {
		var id = heading.id
			? heading.id
			: heading.textContent.trim().toLowerCase()
				.split(' ').join('-').replace(/[!@#$%^&*():]/ig, '').replace(/\//ig, '-')
		headingMap[id] = !isNaN(headingMap[id]) ? ++headingMap[id] : 0
		if (headingMap[id]) {
			heading.id = hashCode(id + '-' + headingMap[id])
		} else {
			heading.id = hashCode(id)
		}
	})
}

$(document).ready(function () {
	document.addEventListener('wpcf7mailsent', function (event) {
		let contactName = $('input[name=your-name]').val()
		let urlThanksPage = window.location.origin + '/' + encodeURIComponent('תודה') + '?cn=' + encodeURIComponent(contactName);
		location = urlThanksPage;
	}, false);
	
	let url = window.location.href;
	$('input.wpcf7-form-control.wpcf7-hidden[name="pageUrl"]').attr('value', encodeURIComponent(url));
	
	$('.accordion-faq li button').click(function (e) {
		let panel = this.nextElementSibling;
		if ($(e.currentTarget.parentElement).hasClass('accordion-section-open')) {
			$('.accordion-section-open').removeClass('accordion-section-open');
			$('.accordion-faq li article').css('max-height', "0px");
		} else {
			$('.accordion-section-open').removeClass('accordion-section-open');
			$('.accordion-faq li article').css('max-height', "0px");
			$(e.currentTarget.parentElement).addClass('accordion-section-open');
			panel.style.maxHeight = panel.scrollHeight + "px";
		}
	});
	
	$('.menu-toggle').click(function () {
		$('body').toggleClass('main-navigation-open');
		$('.page-navigation-open').removeClass('page-navigation-open');
	});
	
	$('.scroll-nav-toggle').click(function () {
		$('.treatment-page').toggleClass('page-navigation-open');
	});
	
	$('.toc-link').click(function () {
		$('.page-navigation-open').removeClass('page-navigation-open');
	});
	
	// Select all links with hashes
	$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.not('[href^="#scroll-nav"]')
		.click(function (event) {
			// On-page links
			if (
				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
				&&
				location.hostname == this.hostname
			) {
				// Figure out element to scroll to
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$('html, body').animate({
						scrollTop: target.offset().top
					}, 1000, function () {
						// Callback after animation
						// Must change focus!
						var $target = $(target);
						$target.focus();
						if ($target.is(":focus")) { // Checking if the target was focused
							return false;
						} else {
							$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
							$target.focus(); // Set focus again
						}
					});
				}
			}
		});
	
	makeIds();
	
	// https://github.com/tscanlin/tocbot
	if (window.tocbot) {
		tocbot.init({
			// Where to render the table of contents.
			tocSelector: '.scroll-nav-layout',
			// Where to grab the headings to build the table of contents.
			contentSelector: '.main-content',
			// Which headings to grab inside of the contentSelector element.
			headingSelector: 'h2',
			// For headings inside relative or absolute positioned containers within content.
			hasInnerContainers: true,
			headingsOffset: 100,
			scrollSmoothOffset: -100
		});
	}
	
	if ($('.slickSlider').length) {
		$('.slickSlider').slick({
			slidesToScroll: 1,
			dots: true,
			infinite: true,
			speed: 500,
			cssEase: 'linear',
			slidesToShow: 1,
			centerMode: true,
			variableWidth: true,
			rtl: true
		});
	}
});